<template>
  <div class="query-box">
    <div id="query-menu" class="query-menu">
      <a-tabs
        tab-position="left"
        type="card"
      >
        <a-tab-pane key="flight">
          <div class="menu-header" slot="tab">
            <l8-icon class="menu-icon icon-booking" type="icon-booking"></l8-icon>
            <p class="menu-name">{{ tripbox.flight.title }}</p>
          </div>
          <div class="menu-main tab-booking">
            <booking :config="tripbox.flight"></booking>
          </div>
        </a-tab-pane>
        <a-tab-pane key="service" v-if="tripbox.service && tripbox.service.enable">
          <div class="menu-header" slot="tab">
            <l8-icon class="menu-icon icon-itinerary-services" type="icon-itinerary-services"></l8-icon>
            <p class="menu-name">{{ tripbox.service.title }}</p>
          </div>
          <div class="menu-main tab-itinerary-services">
            <itinerary-services :config="tripbox.service"></itinerary-services>
          </div>
        </a-tab-pane>
        <a-tab-pane key="addons" v-if="tripbox.addons && tripbox.addons.enable">
          <div class="menu-header" slot="tab">
            <l8-icon class="menu-icon icon-additional-services" type="icon-additional-services"></l8-icon>
            <p class="menu-name">{{ tripbox.addons.title }}</p>
          </div>
          <div class="menu-main tab-additional-services">
            <additional-services :menuChildItems="tripbox.addons.list"></additional-services>
          </div>
        </a-tab-pane>
        <a-tab-pane key="mobile" v-if="tripbox.mobile && tripbox.mobile.enable">
          <div class="menu-header" slot="tab">
            <l8-icon class="menu-icon icon-mobile-app" type="icon-mobile-app"></l8-icon>
            <p class="menu-name">{{ tripbox.mobile.title }}</p>
          </div>
          <div class="menu-main tab-mobile-app">
            <mobile-app :menuChildItems="tripbox.mobile.list"></mobile-app>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import Booking from './queryMenuItem/booking.vue'
import ItineraryServices from './queryMenuItem/itineraryServices.vue'
import AdditionalServices from './queryMenuItem/additionalServices.vue'
import MobileApp from './queryMenuItem/mobileApp.vue'

export default {
  components: {
    Booking,
    ItineraryServices,
    AdditionalServices,
    MobileApp
  },
  data () {
    return {
      tripbox: {
        flight: {
          jjcEnable: true,
          mutipleEnbale: false,
          onlineCityEnable: false
        }
      }
    }
  },
  created () {
    this.getItineraryServicesConfig()
  },
  methods: {
    async getItineraryServicesConfig () {
      if (window.__MICRO_ROOT__) {
        const data = await window.__MICRO_ROOT__.cms?.getPageData('main:/tripbox')

        if (data && data.tripbox) {
          this.tripbox = data.tripbox
        }
      }
    }
  }
}
</script>
